import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ReleaseEndDateChanged extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ReleaseEndDateChanged';

    public constructor(public releaseId: string, public date: string) {
        super(ReleaseEndDateChanged.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ReleaseEndDateChanged): void => {
    const release = state.releases.find((x) => x.id === action.releaseId);
    release.releaseDate = action.date;
};

//@ts-ignore
registerReducer(ReleaseEndDateChanged.ACTION_TYPE, reducer);
